@@ -0,0 +1,62 @@
<template>
    <div class="tooltip">
        <span class="tooltiptext"><slot name="tooltip" /></span>
        <slot name="icon" />
    </div>
</template>
<script setup lang="ts">
</script>
<style lang="scss">
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 350px;
  background-color: var(--color-gray-80);
  color: var(--color-white);
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -191px;
  box-shadow: 0px 12px 8px -4px var(--box-shadow-dark);
  font-size: 1em;
  padding: 8px 16px;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: var(--color-eerie-black-90) transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
